import React, { Component } from "react";

import { DKLabel, DKInput, DKLine, DKButton } from "deskera-ui-library";
import Stepper from "../common/Stepper";
import CampaignManager from "./CampaignManager";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";

class CreateCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    RouteManager.setPresenter(this);
  }
  render() {
    return (
      <div className="column parent-width  parent-height">
        <DKLabel text="Create Campaign" className="fw-m fs-l" />
        <Stepper
          data={CampaignManager.getAllCreationSteps()}
          currentIndex={0}
        />
        <div
          className="column p-xl bg-white border-radius-s parent-width border-box mt-xl align-self-center shadow-s  p-l align-items-center justify-content-center"
          style={{ maxWidth: 900 }}
        >
          <div
            className="column align-items-center parent-width "
            style={{ maxWidth: 580 }}
          >
            <DKLabel
              text='<span style="font-size:30px">🎯</span> Campaign Name'
              className="fw-m fs-xl"
            />
            <DKLabel
              text="Enter a name to help you remember what this campaign is all about. Only you will see this."
              className="text-gray fs-m mt-s text-align-center"
            />
            <div className="parent-width">
              <DKInput
                title=""
                value="Campaign 1"
                onChange={() => {}}
                direction="vertical"
                className="mt-xl"
              />
            </div>
            <DKLine className="m-xxl" />
            <DKLabel text="Select a List" className="fw-m fs-xl" />
            <DKLabel
              text="Select the list or lists you would like this campaign to send to. Filter your campaign to specific contacts that match conditions."
              className="text-gray fs-m mt-s text-align-center"
            />
            {this.getSegment("Segment", "Contact count", "fw-m mt-xxl")}
            {this.getSegment("Master List", "120470")}
            {this.getSegment("Segment List 1", "3400")}
            {this.getSegment("Segment List 1", "3400")}
            {this.getSegment("Segment List 1", "3400")}

            <DKLabel
              text="Note: You can change the list later too."
              className="text-grays mt-xxl bg-deskera-secondary p-h-s p-v-xs border-radius-s"
            />

            <div className="row justify-content-center mt-l mb-l">
              <DKButton
                title="+ Create new segment"
                className="bg-gray2 border-m "
              />
              <DKButton
                title="Proceed"
                className="bg-app text-white ml-m"
                onClick={() => {
                  RouteManager.navigateToPage(
                    PAGE_ROUTES.SELECT_CAMPAIGN_TEMPLATE
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  getSegment(title, count, className) {
    return (
      <div
        className={"row justify-content-between mt-r " + className}
        style={{ maxWidth: 400 }}
      >
        <div>
          <div className="row">
            <div className="p-s border-radius-s border-m" />
            <DKLabel text={title} className="ml-r" />
          </div>
        </div>
        <DKLabel text={count} />
      </div>
    );
  }
}

export default CreateCampaign;
